export default __webpack_public_path__ + "static/media/lds-logo_uk.b36c6d4c665a7681.svg";